import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { app_languageTypes } from "./app_languageTypes";
import app_languageService from "./app_languageService";

interface app_languageState {
    app_language: app_languageTypes[] | null;
    loading: boolean;
    error: string | null;
}

const initialState: app_languageState = {
    app_language: null,
    loading: false,
    error: null,
};

export const getAppLanguages = createAsyncThunk<app_languageTypes[], void, {rejectValue:string}>(
    "appLanguage/getAppLanguages",
    async (_, { rejectWithValue}) => {

        try {
            const response = await app_languageService.getAppLanguages();
            return response;
        } catch (error: any) {
            return rejectWithValue(error);
        }
    }
);



const app_languageSlice = createSlice({
    name: "app_language",
    initialState,
    reducers: {
        resetError: (state) => {
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        
        builder.addCase(getAppLanguages.fulfilled, (state, action) => {
            state.app_language = action.payload;
            state.loading = false;
            state.error = null;
        });
        builder.addCase(getAppLanguages.rejected, (state, action) => {
            state.error = action.payload ?? null;
            state.loading = false;
            state.app_language = null;
        });
        builder.addCase(getAppLanguages.pending, (state) => {
            state.loading = true;
            state.app_language = null;
            state.error = null;
        });

    },
});

export default app_languageSlice.reducer;